import Template from "../../../core/templates/baseApp";
import { StartPage } from "../pages/StartPage";
import { WritePage } from "../pages/WritePage";
import CorrectedPage from "../pages/corrected";
import MyEssays from "../pages/myEssays";
import ThemesPage from "../pages/themes";
import { WaitingEssayPage } from "../pages/waitingEssay";

export const EssayRoutes = [
  {
    path: 'temas',
    element: (
      <Template>
        <ThemesPage />
      </Template>
    )
  },
  {
    path: 'minhas_redacoes',
    element: (
      <Template>
        <MyEssays />
      </Template>
    )
  },
  {
    path: 'start/:themeSlug',
    element: (
      <Template>
        <StartPage />
      </Template>
    )
  },
  {
    path: 'escrevendo/:themeSlug',
    element: (
      <Template>
        <WritePage />
      </Template>
    )
  },
  {
    path: 'correcao/:slug/:tryNumber',
    element: (
      <Template>
        <CorrectedPage />
      </Template>
    )
  },
  {
    path: 'aguardando/:slug',
    element: (
      <Template>
        <WaitingEssayPage />
      </Template>
    )
  }
];
